import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import SellerLayout from './components/SellerLayout';
import Footer from './components/HomePageComponents/Footer';
import UserFilters from './components/HomePageComponents/UserFilters';
import WithoutParts from './components/HomePageComponents/WithoutParts';
import OfferTableHomePage from './components/Tables/Table/OfferTableHomePage';
import RequestTableHomePage from "./components/Tables/Table/RequestTableHomePage";
import OfferDetails from "./components/OffersComponents/OfferDetails";
import PartRequestDetails from "./components/RequestComponents/PartRequestDetails";

import { getPartOffer } from "./reduxStore/entities/partOffers";
import { getNewPartRequests } from "./reduxStore/entities/partRequest";
import { getUserFilters } from "./reduxStore/entities/userFilters";

const HomePage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const partRequestData = useSelector((state) => state.partRequests.newPartRequests?.rows || []);
  const partRequestCount = useSelector((state) => state.partRequests.newPartRequests?.count || 0);
  const partOfferData = useSelector((state) => state.partOffers.partOffer?.rows || []);
  const partOfferCount = useSelector((state) => state.partOffers.partOffer?.count || 0);
  const userFiltersData = useSelector((state) => state.userFilters.userFilters || []);

  const [selectedOfferId, setSelectedOfferId] = useState(null);
  const [selectedRequestId, setSelectedRequestId] = useState(null);
  const [expandedFilter, setExpandedFilter] = useState(null);

  const [offerPage, setOfferPage] = useState(0);
  const [offerRowsPerPage, setOfferRowsPerPage] = useState(15);

  const [requestPage, setRequestPage] = useState(0);
  const [requestRowsPerPage, setRequestRowsPerPage] = useState(15);

  const [loadingOffers, setLoadingOffers] = useState(false);
  const [loadingRequests, setLoadingRequests] = useState(false);
  const [loadingFilters, setLoadingFilters] = useState(true);

  useEffect(() => {
    async function fetchFilters() {
      await dispatch(getUserFilters());
      setLoadingFilters(false);
    }
    fetchFilters();
  }, [dispatch]);

  useEffect(() => {
    async function fetchOffers() {
      setLoadingOffers(true);
      await dispatch(getPartOffer({ limit: offerRowsPerPage, offset: offerPage * offerRowsPerPage }));
      setLoadingOffers(false);
    }
    fetchOffers();
  }, [dispatch, offerPage, offerRowsPerPage]);

  useEffect(() => {
    async function fetchRequests() {
      setLoadingRequests(true);
      await dispatch(getNewPartRequests({ limit: requestRowsPerPage, offset: requestPage * requestRowsPerPage }));
      setLoadingRequests(false);
    }
    fetchRequests();
  }, [dispatch, requestPage, requestRowsPerPage]);

  if (loadingFilters) return null;

  if (userFiltersData.length === 0) {
    return (
      <div className="home-page" style={styles.pageBackground}>
        <SellerLayout>
          <WithoutParts />
        </SellerLayout>
      </div>
    );
  }

  if (selectedOfferId) {
    return (
      <SellerLayout>
        <OfferDetails id={selectedOfferId} onBack={() => setSelectedOfferId(null)} />
      </SellerLayout>
    );
  }

  if (selectedRequestId) {
    return (
      <SellerLayout>
        <PartRequestDetails id={selectedRequestId} onBack={() => setSelectedRequestId(null)} />
      </SellerLayout>
    );
  }

  return (
    <div className="home-page" style={styles.pageBackground}>
      <SellerLayout>
        <div style={styles.title}>Naslovna strana</div>
        <div style={styles.title}>Asortiman</div>

        <UserFilters
          userFiltersData={userFiltersData}
          expandedFilter={expandedFilter}
          handleToggleExpand={setExpandedFilter}
          onClick={() => navigate('/store')}
        />

        <div style={styles.container}>
          <div style={styles.title}>Moje ponude ({partOfferCount})</div>
          <OfferTableHomePage
            count={partOfferCount}
            fetchedActiveCarOffers={partOfferData}
            rowsPerPage={offerRowsPerPage}
            setRowsPerPage={setOfferRowsPerPage}
            page={offerPage}
            setPage={setOfferPage}
            onRowSelect={setSelectedOfferId}
          />

          <div style={styles.title}>Novi zahtevi ({partRequestCount})</div>
          <RequestTableHomePage
            count={partRequestCount}
            fetchedActiveCarRequests={partRequestData}
            rowsPerPage={requestRowsPerPage}
            setRowsPerPage={setRequestRowsPerPage}
            page={requestPage}
            setPage={setRequestPage}
            onRowSelect={setSelectedRequestId}
          />

          {selectedOfferId && (
            <div style={styles.selectedOfferText}>
              <strong>Selektovana ponuda ID:</strong> {selectedOfferId}
            </div>
          )}
        </div>

        <Footer />
      </SellerLayout>
    </div>
  );
};

export default HomePage;

const styles = {
  pageBackground: {
    backgroundColor: '#FFF',
    minHeight: '100vh',
  },
  title: {
    opacity: 1,
    color: 'rgba(0, 0, 0, 0.87)',
    fontSize: '34px',
    fontWeight: 400,
    letterSpacing: '0.25px',
    lineHeight: '42px',
    marginBottom: '40px',
    marginLeft: '20px',
  },
  container: {
    padding: '0 20px'
  },
  selectedOfferText: {
    marginTop: 20,
    marginLeft: 20,
  }
};
